import { useMutation } from '@apollo/client';
import { Table, notification } from 'antd';
import { useState } from 'react';
import dayjs from 'dayjs';
import { BULK_DELETE_PROPERTIES, BULK_UNARCHIVE_PROPERTIES, DELETE_PROPERTY, UN_ARCHIVE_PROPERTY } from '@src/util/mutation/properties.mutation';
import { archiveTaskInLibraryMutation } from '@src/util/mutation/taskInLibrary.mutation';

import { useSelector } from 'react-redux';
import Spinner from '@src/components/spinner';


export const ArcheiveTaskGrid = ({data, refetch, taskListRefetch, objectType, isLegacyTenant=false}) => {

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };


  const [hoveredRow, setHoveredRow] = useState(null);
  
  const rowClassName = (record) => {
    return record.key === hoveredRow ? 'hovered-row' : '';
  };

   
  const handleRowMouseEnter = (record) => {
    setHoveredRow(record.key);
  };


  const handleRowMouseLeave = () => {
    setHoveredRow(null);
  };

  const [api, contextHolder] = notification.useNotification();

  const [archiveTask, {loading, error}] = useMutation(archiveTaskInLibraryMutation);

  const [deleteProperty, {loading: deleteProperyLoading,}] = useMutation(DELETE_PROPERTY);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const { refetchedFiltered } = useSelector(state => state.archiveReducer);

  const handelRestore= async(id, label) => {
    console.log(id, "oddd")
    await archiveTask({
        variables:{
            id, 
            isArchived: false
        }
    });

    api.success({
      message:`Task was restored`,
      placement:'top',
      className:'notification-without-close',
    });
    await taskListRefetch();
    await refetch();
    if(refetchedFiltered){
      refetchedFiltered();
    };

  };

  const [propertyName, setPropertyName] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [deleteBulkProperty, {loading: deleteBulkPropertyloading}] = useMutation(BULK_DELETE_PROPERTIES)
  const handelDelete= async () => {
    if(selectedRowKeys?.length>0){
      const properties = data?.filter((data)=> selectedRowKeys.find((key)=>data.key == key));
      await deleteBulkProperty({
        variables:{
          input: {properties}
        }
      });
      
      setConfirmationModal(false);
      api.success({
        message:`${selectedRowKeys?.length>1 ? selectedRowKeys?.length+" properties were deleted" : "1 property was deleted"}`,
        placement:'top',
        className:'notification-without-close',
      });
      setSelectedRowKeys([]);
      await refetch();
      await taskListRefetch();
      if(refetchedFiltered){
        refetchedFiltered();
      }
      setPropertyName("");
      setPropertyId("");


    }else{
      
      await deleteProperty({variables:{input: {id:propertyId, objectType}}});
      setConfirmationModal(false);
      api.success({
        message:`${propertyName} property was deleted`,
        placement:'top',
        className:'notification-without-close',
      });
      await refetch();
      await taskListRefetch();
      if(refetchedFiltered){
        refetchedFiltered();
      }
      setPropertyName("");
      setPropertyId("");

    }
  }

  const setProperties = (key,label)=>{
    setPropertyName(label);
    setConfirmationModal(true);
    setPropertyId(key);
  }

  function truncateText(text, maxWords) {
    // Split the text into an array of words
    const words = text.split(' ');
  
    
    if(words[0]?.length >15){maxWords=2}
    // If the number of words is less than or equal to the maximum allowed, return the original text
    if (words.length <= maxWords) {
      return text;
    }
  
    // Otherwise, join the first "maxWords" words and add ellipsis at the end
    return words.slice(0, maxWords).join(' ') + '...';
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'label',
      key: 'label',
      sorter: (a, b) => a.label.localeCompare(b.label),
      sortOrder: sortedInfo.columnKey === 'label' ? sortedInfo.order : null,
      width:400,
      ellipsis:true,
      render: (_, record) => {
        const showActions = hoveredRow === record.key;
        return (
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
            <div style={{lineHeight:'35px'}} className='truncated-text'>
              {showActions?truncateText(record.label,3):truncateText(record.label,3)}
            </div>

            {showActions && selectedRowKeys?.length==0 &&
            <div style={{width:'100%', display:'flex', justifyContent:'flex-end' ,alignItems:'center', columnGap:'10px'}}>
              <button style={{marginLeft:'10%'}} className="sm-btn" type="link" onClick={()=>handelRestore(record._id)} >
                Restore
              </button>
              {/* <button  className="sm-btn" type="link" onClick={()=>setProperties(record.key, record.label)} >
                Delete
              </button> */}
            </div>
            }
          </div>
      )},
    },
    ...(isLegacyTenant ? [{
      title: 'Group',
      dataIndex: 'group',
      key: 'group',
      ellipsis:true,
      width:200,
    }] : []),
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      ellipsis:true,
      width:200,
      render:(_,record)=>{
        return (dayjs((record.createdAt)).format('DD-MM-YY hh:mm A'))
      }
    },
  ];
  
  const [selectedRowKeys, setSelectedRowKeys]=useState([])

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  
  const [restoreProperties, {loading: restorePropertiesLoading}] = useMutation(BULK_UNARCHIVE_PROPERTIES)
  const bulkRestore= async()=>{
    await restoreProperties({variables:{ids: {ids: selectedRowKeys}}});
    api.success({
      message:`${selectedRowKeys.length<2 ?  selectedRowKeys.length +' property was restored' : selectedRowKeys.length + ' properties were restored'} `,
      placement:'top',
      className:'notification-without-close',
    });
    setSelectedRowKeys([]);
    await taskListRefetch();
    await refetch();
    if(refetchedFiltered){
      refetchedFiltered();
    }
  };

  const customHeader =(

    <div className='table-footer' id="selection-options">
      

      {selectedRowKeys?.length>0 &&
      <>
          <small className='small-text'> {selectedRowKeys?.length} selected</small>

          {/* <div onClick={handelRestore}  style={{cursor:'pointer'}}>
              <FontAwesomeIcon icon={faRecycle} style={{marginRight:'5px'}}/> <span>Restore</span>
          </div> */}

          {/* <div onClick={()=> setConfirmationModal(true)} style={{cursor:'pointer'}}>
              <FontAwesomeIcon icon={faTrashCan} style={{marginRight:'5px'}}/> <span>Delete</span>
          </div> */}


      </>
  }
    </div>
  )

  

  return (
    <div 
    className='setting-grid'>
      {contextHolder}
      {loading || restorePropertiesLoading ?
        <Spinner/>        
      :
        <Table 
          columns={columns} 
          className='moveGroupTable curvedTable'
          dataSource={data} 
          title={selectedRowKeys?.length>0 ? () => customHeader : null}
          rowSelection={rowSelection}
          onChange={handleChange} 
          
          
          onRow={(record) => ({
            onMouseEnter: () => handleRowMouseEnter(record),
            onMouseLeave: () => handleRowMouseLeave(),
          })}
          rowClassName={rowClassName}


          />
        }

        {
        //   confirmationModal &&
        //   <BulkDeleteConfirmationModal
        //     visible={confirmationModal}
        //     onClose={()=>setConfirmationModal(false)}
        //     deleteRecord={handelDelete}
        //     refresh = {async()=>{
        //       await refetch();
        //       await taskListRefetch();
        //     }} 
        //     loading={deleteProperyLoading || deleteBulkPropertyloading}
        //     label={propertyName}
        //     title={""}
        //     properties={selectedRowKeys}

        //   />
        }

    </div>
  );
};
